import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, CdkDragStart, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { EventService } from 'src/app/services/event.service';
import { PropertyService } from 'src/app/services/property.service';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { EventResource } from 'src/app/interfaces/event-resource';
import { OverlayService } from 'src/app/services/overlay.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ContractService } from 'src/app/services/contract.service';
import { AttachmentService } from 'src/app/services/attachment.service';
import { HttpClient } from '@angular/common/http';
import { MatSelectChange } from '@angular/material/select';
import { AttachmentResource } from 'src/app/interfaces/attachment-resource';
import { EnvironmentService } from 'src/app/services/environment.service';
/**
 * The Options used for sorting
 */
interface SortOption {
  /**
   * The Value of the Filteroption
   */
  value: string;
  /**
   * The viewValue (visible to the User) of the Filteroption
   */
  viewValue: string;
  /**
   * Is the  Filteroption disabled
   */
  state?: boolean;
}

@Component({
  selector: 'app-campaign',
  templateUrl: './campaign.component.html',
  styleUrls: ['./campaign.component.scss']
})
export class CampaignComponent implements OnInit {
  avalibleEvents = [];
  inUseEvents = [];
  allEvents = [];

  avalibleEvents_Advent = [];
  inUseEvents_Advent = [];
  allEvents_Advent = [];

  avalibleEvents_ServiceCentre = [];
  inUseEvents_ServiceCentre = [];
  allEvents_ServiceCentre = [];
  tyepSelectForm: UntypedFormGroup;

  has_adventCalender$: BehaviorSubject<string | boolean> = new BehaviorSubject(null);
  files: File[] = [];
  addForm: UntypedFormGroup;

  intoBoxes = [];
  ReturnintoBoxes = [];
  videoURL;
  currentAttachment: AttachmentResource;
  loading: boolean = true;
    /**
   * The Pio of the First Pos
   */
    start: number = 9999;
  public sortOptions: SortOption[] = [
    { value: "component_web_landing_page", viewValue: "Karussell Web Startseite" },
    //App hat vorest  kein Karousell mehr
    // { value: "component_app_service_center", viewValue: "Karussell App Kundencenter" },
    //  { value: "component_web_intro_landing_page", viewValue: "Startseitengestaltung Web" }
  ];

  public boxTypes: SortOption[] = [
    { value: "NONE", viewValue: "Bild nicht anzeigen" },
    { value: "LEFT", viewValue: "Links vom Text" },
    { value: "RIGHT", viewValue: "Rechts vom Text" }
  ];

  public states: SortOption[] = [
    { value: "NEW", viewValue: "Neue" },
    { value: "DRAFT", viewValue: "Entwurf" },
    { value: "PUBLISHED", viewValue: "Veröffentlicht" }
  ];


  public activeBoxes: SortOption[] = [
    { value: "NEW", viewValue: "Neue  Box erstellen" },
  ];
  constructor(private eventService: EventService,
    private propertyService: PropertyService,
    private overlayService: OverlayService,
    private fb: UntypedFormBuilder,
    private contractService: ContractService,
    private attachmentService: AttachmentService,
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) {
    this.addForm = this.fb.group({
      image: [''],
      imageAlignMent: ["LEFT", [Validators.required]],
      state: ['NEW', [Validators.required]],
      text: ['', Validators.required]
    })


  }

  ngOnInit() {
    this.tyepSelectForm = this.fb.group({
      type: ["component_web_landing_page"]
    })

    combineLatest([
      this.contractService.has_adventCalender$,
      this.eventService.getEventsForCampaigns(0, 999),
      this.contractService.component_web_intro_landing_page$
    ]).pipe(
      map(([hasCalendar, events, value]: (any)) => {
        if (hasCalendar == true) {
          this.sortOptions.push({ value: "component_advent", viewValue: "Adventskalender" })
        }
        this.allEvents = events.content;

        this.propertyService.component_web_landing_page$.subscribe((component_web_landing_page: any) => {
          events.content.forEach((element: EventResource) => {
            component_web_landing_page.forEach((component_web_landing_page, index) => {
              if (element.publicId == component_web_landing_page) {
                this.inUseEvents.push(element);
              }
            });
         
          });
          this.inUseEvents = this.inUseEvents.sort((a, b) => b.priority - a.priority);
        })

        this.propertyService.component_advent$.subscribe((component_advent: any) => {
          events.content.forEach((element: EventResource) => {
            component_advent.forEach((component_web_landing_page, index) => {
              if (element.publicId == component_web_landing_page) {
                //Add Property for Sorting => Copy  Number from Title and add leading zero
                let number = element.title.split(" ")[0];
                if (number.length < 2) {
                  element["NUMBER"] = "0" + number
                } else {
                  element["NUMBER"] = number
                }
                this.inUseEvents_Advent.push(element);
              }
            });
          });
          //Sort Elements
          this.inUseEvents_Advent.sort((a, b) => (a['NUMBER'] > b['NUMBER']) ? 1 : -1);
        })

        this.propertyService.component_app_service_center$.subscribe((component_app_service_center: any) => {
          events.content.forEach((element: EventResource) => {
            component_app_service_center.forEach((component_app_service_center_element, index) => {
              if (element.publicId == component_app_service_center_element) {
                this.inUseEvents_ServiceCentre.push(element);
              }
            });
          });
        })

        this.avalibleEvents = this.allEvents.filter(x => !this.inUseEvents.includes(x));
        this.avalibleEvents_ServiceCentre = this.allEvents.filter(x => !this.inUseEvents_ServiceCentre.includes(x));
        this.avalibleEvents_Advent = this.allEvents.filter(x => !this.inUseEvents_Advent.includes(x));

        if (value != null && value != false) {
          this.intoBoxes = JSON.parse(String(value));
          this.intoBoxes.forEach((element, index) => {
            //Push to select Box Dropdownoptions
            this.activeBoxes.push({ value: element[0], viewValue: `Infobox ${index + 1}` });
            this.attachmentService.getInfoData(element[0]).subscribe(value => {
              this.http.get(value.url, { responseType: 'text' }).subscribe(value => {
                this.intoBoxes[index]["TEXT_FILE"] = value;
              })
            })
            this.attachmentService.getInfoData(element[1]).subscribe(value => {
              this.intoBoxes[index]["IMAGE_FILE"] = value?.url
            })
            this.ReturnintoBoxes.push(element);
          });
        }
      })
    ).subscribe(() => {
      this.loading = false;
    })
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }

  updateAdvertisingTiles() {
    //Comvert String to the necessary fornat
    //Example Sting for changeing the advertising
    //let value = "[\"4ed47d2b-4209-4236-a9d4-a6f75166228c\",\"571d6080-3dca-40d3-ad17-2eb01370d3fd\"]";



    let temp = "[";
    this.inUseEvents.forEach((element: EventResource, index) => {
      element.priority = this.start - index;
      if (index == this.inUseEvents.length - 1) {
        temp += '\"' + element.publicId + "\"]";
      } else {
        temp += '\"' + element.publicId + '\",';
      }
      this.eventService.editEvent(element).subscribe();
    });

    if (this.inUseEvents.length == 0) {
      this.propertyService.updateProperty("component_web_landing_page", "[]").subscribe(value => {
        this.overlayService.openSnackBar("Werbeflächen erfolgreich bearbeitet!")
      })
    } else {
      this.propertyService.updateProperty("component_web_landing_page", temp).subscribe(value => {
        this.overlayService.openSnackBar("Werbeflächen erfolgreich bearbeitet!")
      })
    }

  }

  updateAdventTiles() {
    //Comvert String to the necessary fornat
    //Example Sting for changeing the advertising
    //let value = "[\"4ed47d2b-4209-4236-a9d4-a6f75166228c\",\"571d6080-3dca-40d3-ad17-2eb01370d3fd\"]";
    let temp = "[";
    this.inUseEvents_Advent.forEach((element: EventResource, index) => {
      if (index == this.inUseEvents_Advent.length - 1) {
        temp += '\"' + element.publicId + "\"]";
      } else {
        temp += '\"' + element.publicId + '\",';
      }
    });
    if (this.inUseEvents_Advent.length == 0) {
      this.propertyService.updateProperty("component_advent", "[]").subscribe(value => {
        console.log("value Update", value)
        this.overlayService.openSnackBar("Adventskalender erfolgreich bearbeitet!")
      })
    } else {
      this.propertyService.updateProperty("component_advent", temp).subscribe(value => {
        console.log("value Update", value)
        this.overlayService.openSnackBar("Adventskalender erfolgreich bearbeitet!")
      })
    }


  }

  updateServiceCentre() {
    //Comvert String to the necessary fornat
    //Example Sting for changeing the advertising
    //let value = "[\"4ed47d2b-4209-4236-a9d4-a6f75166228c\",\"571d6080-3dca-40d3-ad17-2eb01370d3fd\"]";
    let temp = "[";
    this.inUseEvents_ServiceCentre.forEach((element: EventResource, index) => {
      if (index == this.inUseEvents_ServiceCentre.length - 1) {
        temp += '\"' + element.publicId + "\"]";
      } else {
        temp += '\"' + element.publicId + '\",';
      }
    });

    if (this.inUseEvents_ServiceCentre.length == 0) {
      this.propertyService.updateProperty("component_app_service_center", "[]").subscribe(value => {
        console.log("value Update", value)
        this.overlayService.openSnackBar("Werbeflächen erfolgreich bearbeitet!")
      })
    } else {
      this.propertyService.updateProperty("component_app_service_center", temp).subscribe(value => {
        console.log("value Update", value)
        this.overlayService.openSnackBar("Werbeflächen erfolgreich bearbeitet!")
      })
    }
  }

  updateAdvertsing() {
    if (this.addForm.invalid) {
      return;
    }
    let t = {
      "clientRef": this.currentAttachment.clientRef,
      "publicId": this.currentAttachment.publicId,
      "originalFilename": this.currentAttachment.originalFilename,
      "type": "text/html",
      "content": this.addForm.value.text
    }

    this.attachmentService.updateHTMLAttachment(t).subscribe(value => {
      console.log("FROM UPDATE:", value);
    })
  }

  public dragging: boolean;

  public handleDragStart(event: CdkDragStart): void {
    this.dragging = true;
  }

  addToListEvents(event: MouseEvent, e: EventResource) {
    if (this.dragging) {
      this.dragging = false;
      return
    }
    this.avalibleEvents.splice(this.avalibleEvents.indexOf(e), 1)
    this.inUseEvents.push(e)
  }

  deltefromListEvents(event: MouseEvent, e: EventResource) {
    if (this.dragging) {
      this.dragging = false;
      return
    }
    this.inUseEvents.splice(this.inUseEvents.indexOf(e), 1)
    this.avalibleEvents.push(e)
  }


  addToListAdvents(event: MouseEvent, e: EventResource) {
    if (this.dragging) {
      this.dragging = false;
      return
    }
    this.avalibleEvents_Advent.splice(this.avalibleEvents_Advent.indexOf(e), 1)
    this.inUseEvents_Advent.push(e)
  }

  deltefromListAdvents(event: MouseEvent, e: EventResource) {
    if (this.dragging) {
      this.dragging = false;
      return
    }
    this.inUseEvents_Advent.splice(this.inUseEvents_Advent.indexOf(e), 1)
    this.avalibleEvents_Advent.push(e)
  }

  //TODO Upload image to S3 as Attachment
  onSelect(event) {
    //   console.log(event.addedFiles[0]);
    this.files.push(...event.addedFiles);
  }


  onRemove(event) {
    console.log(event);
    this.files.splice(this.files.indexOf(event), 1);
  }

  changeActiveBox(event: MatSelectChange) {
    this.attachmentService.getHTMLAttachment(event.value).subscribe(value => {
      this.currentAttachment = value;
    })

    if (event.value == 'NEW') {
      this.addForm.patchValue({
        image: '',
        text: '',
        imageAlignMent: 'LEFT',
        state: 'NEW'
      })
    } else {
      this.ReturnintoBoxes.forEach(element => {
        if (element[0] == event.value) {
          this.addForm.patchValue({
            image: element['IMAGE_FILE'],
            text: element['TEXT_FILE'],
            imageAlignMent: element[2],
            state: element[3]
          })
        }
      });
    }


  }
}
